module.exports = __webpack_public_path__ + "static/media/Tirtouga_gaussian2.64b8ae00.png";